import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const Holidays = () => {
  const images = [
    { id: 35, src: '/images/holidays/35.jpg', alt: 'Image 35' },
    { id: 36, src: '/images/holidays/36.jpg', alt: 'Image 36' },
    { id: 37, src: '/images/holidays/37.jpg', alt: 'Image 37' },
    { id: 38, src: '/images/holidays/38.jpg', alt: 'Image 38' },
    { id: 39, src: '/images/holidays/39.jpg', alt: 'Image 39' },
    { id: 40, src: '/images/holidays/40.jpg', alt: 'Image 40' },
    { id: 1, src: '/images/holidays/1.jpg', alt: 'Image 1' },
    { id: 2, src: '/images/holidays/2.jpg', alt: 'Image 2' },
    { id: 3, src: '/images/holidays/3.jpg', alt: 'Image 3' },
    { id: 4, src: '/images/holidays/4.jpg', alt: 'Image 4' },
    { id: 5, src: '/images/holidays/5.jpg', alt: 'Image 5' },
    { id: 6, src: '/images/holidays/6.jpg', alt: 'Image 6' },
    { id: 7, src: '/images/holidays/7.jpg', alt: 'Image 7' },
    { id: 8, src: '/images/holidays/8.jpg', alt: 'Image 8' },
    { id: 9, src: '/images/holidays/9.jpg', alt: 'Image 9' },
    { id: 10, src: '/images/holidays/10.jpg', alt: 'Image 10' },
    { id: 11, src: '/images/holidays/11.jpg', alt: 'Image 11' },
    { id: 12, src: '/images/holidays/12.jpg', alt: 'Image 12' },
    { id: 13, src: '/images/holidays/13.jpg', alt: 'Image 13' },
    { id: 14, src: '/images/holidays/14.jpg', alt: 'Image 14' },
    { id: 15, src: '/images/holidays/15.jpg', alt: 'Image 15' },
    { id: 16, src: '/images/holidays/16.jpg', alt: 'Image 16' },
    { id: 17, src: '/images/holidays/17.jpg', alt: 'Image 17' },
    { id: 18, src: '/images/holidays/18.jpg', alt: 'Image 18' },
    { id: 19, src: '/images/holidays/19.jpg', alt: 'Image 19' },
    { id: 20, src: '/images/holidays/20.jpg', alt: 'Image 20' },
    { id: 21, src: '/images/holidays/21.jpg', alt: 'Image 21' },
    { id: 22, src: '/images/holidays/22.jpg', alt: 'Image 22' },
    { id: 23, src: '/images/holidays/23.jpg', alt: 'Image 23' },
    { id: 24, src: '/images/holidays/24.jpg', alt: 'Image 24' },
    { id: 25, src: '/images/holidays/25.jpg', alt: 'Image 25' },
    { id: 26, src: '/images/holidays/26.jpg', alt: 'Image 26' },
    { id: 27, src: '/images/holidays/27.jpg', alt: 'Image 27' },
    { id: 28, src: '/images/holidays/28.jpg', alt: 'Image 28' },
    { id: 29, src: '/images/holidays/29.jpg', alt: 'Image 29' },
    { id: 30, src: '/images/holidays/30.jpg', alt: 'Image 30' },
    { id: 31, src: '/images/holidays/31.jpg', alt: 'Image 31' },
    { id: 32, src: '/images/holidays/32.jpg', alt: 'Image 32' },
    { id: 33, src: '/images/holidays/33.jpg', alt: 'Image 33' },
    { id: 34, src: '/images/holidays/34.jpg', alt: 'Image 34' },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <>
      <Helmet>
        <title>Holidays Gallery</title>
      </Helmet>

      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        <img
          src="/img/icons/cloud.png"
          alt="vs-breadcrumb-icon"
          className="vs-breadcrumb-icon-1 animate-parachute"
        />
        <img
          src="/img/icons/ballon-sclation.png"
          alt="vs-breadcrumb-icon"
          className="vs-breadcrumb-icon-2 animate-parachute"
        />
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">Holidays</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="gallery-container">
        <div className="gallery-grid">
          {images.map((image, index) => (
            <img
              key={image.id}
              src={image.src}
              alt={image.alt}
              loading="lazy"
              className="gallery-image-item borderr"
              onClick={() => openModal(index)}
            />
          ))}
        </div>

        {isModalOpen && (
          <div className="modal-overlay">
            <button className="modal-close-button" onClick={closeModal}>
              &times;
            </button>
            <div className="modal-content-container">
              <button className="modal-prev-button" onClick={prevImage}>
                &#10094;
              </button>
              <div className="modal-image-container">
                <img
                  src={images[currentImageIndex].src}
                  alt={images[currentImageIndex].alt}
                  className="modal-image"
                />
              </div>
              <button className="modal-next-button" onClick={nextImage}>
                &#10095;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Holidays;
